import React, { useCallback, useMemo, useRef, useState } from "react";
import { connect } from "dvajs";
import { message as toast } from "antd";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { FocusSDK } from "@/utils";
import imgDefault from "@/components/DefaultPage/imgs/img-load-failed.png";
import { addXtoken } from "@/utils/addToken";
import IconFont from "@/components/icon";
import lodashGet from "lodash/get";
import styles from "./imagelinkcard.module.less";
import TextCard from "./TextCard";
import { MultiCardTemplateType } from "@/utils/chat/message";
import { Avatar } from "@/baseComponents/Avatar";

interface IProps {
  message: any;
  selectedSession: Function;
}

function ImageTextCardLink({ message, selectedSession }: IProps) {
  const isPrivateNet = useRef<boolean>(FocusSDK.isPrivateNet());
  const sender = message?.sender;
  // 数据
  const dataInfo = useMemo(() => {
    const data = lodashGet(message, "data.0", {});
    let d;
    if (data?.orgNumberCard) {
      d = data?.orgNumberCard;
    } else {
      d = data;
    }
    return d || {};
  }, [message]);

  // 点击跳转
  const handleClickLink = useCallback((url: string) => {
    if (!url) {
      return;
    }
    const parseUrl = DeeplinkEvent.parseDeeplink(url);
    if (!parseUrl) {
      toast.warn("当前跳转链接不符合规范");
      return;
    }
    if (parseUrl.pathname && parseUrl.pathname.includes("browser")) {
      const mparam = parseUrl.mparam || {};
      let realUrl = isPrivateNet.current ? mparam.egovUrl : mparam.url;
      if (!realUrl) {
        toast.warn("该应用不支持在当前网络环境下打开");
        return;
      }
      window.open(realUrl);
    } else {
      DeeplinkEvent.open(url);
    }
  }, []);

  const getLinkClass = useCallback((link: string) => {
    if (link) {
      return "cursor-pointer";
    } else {
      return "";
    }
  }, []);

  const imgOnError = (e: any) => {
    try {
      if (e.target) {
        e.target.src = imgDefault;
        e.target.className = "error";
      }
    } catch (e) {}
  };

  const getRealImageUrl = useCallback((url: string, egovUrl: string) => {
    return addXtoken(url);
  }, []);

  const hasMainImage = useMemo(() => {
    return dataInfo?.imageUrl;
  }, [dataInfo]);

  const hasDesc = useMemo(() => {
    return dataInfo?.content;
  }, [dataInfo]);

  // 主图
  const mainImage = useMemo(() => {
    return hasMainImage ? <img src={dataInfo?.imageUrl} onError={imgOnError} /> : null;
  }, [dataInfo, hasMainImage]);

  const isTextCard = useMemo(() => {
    return dataInfo?.type === MultiCardTemplateType.Text;
  }, []);

  return isTextCard ? (
    <TextCard message={message} />
  ) : (
    <div
      className={`${styles["multi-imgcard-link-content-wrap"]} ${getLinkClass(dataInfo?.url)}`}
      onClick={() => handleClickLink(dataInfo?.url)}
    >
      {hasDesc ? (
        <div className={`${styles["title-wrap"]} two-lines`}>{dataInfo?.title}</div>
      ) : null}
      <div
        className={`${styles["content-wrap"]} ${styles[dataInfo?.imagePosition]} ${
          hasDesc ? "" : styles["no-desc"]
        }`}
      >
        {hasDesc ? (
          <span className={styles["desc"]}>{dataInfo?.content}</span>
        ) : (
          <span className={`${styles["title-wrap"]} two-lines`}>{dataInfo?.title}</span>
        )}
        {mainImage}
      </div>
      <div className={styles["footer-wrap"]}>
        <Avatar
          className={styles["avatar"]}
          src={dataInfo?.orgAvatar}
          name={dataInfo?.orgName || ""}
          styleObj={{ width: "14px", height: "14px", fontSize: "6px" }}
        />
        <span className={`${styles["text"]} ellipsis`}>{dataInfo?.orgName}</span>
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageTextCardLink);
